import GridOn from '@mui/icons-material/GridOn';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function GridIcon(props: FixMe) {
  return <GridOn {...props} />;
}

export default GridIcon;
